class EmailValidatorService {
  constructor() {
    this.emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-\d]+\.)+[a-zA-Z]{2,}))$/;
  }

  validateEmail(email) {
    return !!(email && email.match(this.emailRegex));
  }
}

export const EmailValidator = new EmailValidatorService();



// WEBPACK FOOTER //
// ./src/services/validators/email.js